<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/ag3Kfj/tc-custom/9781626569836.jpg?1738123076687" alt="This image is the cover for the book Leaders Made Here, The High Performance Series"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Leaders Made Here, The High Performance Series
      </h1>
      <p class="bookDescription body article font2">
        <b>The business leadership expert and author of <i>Chess, Not Checkers</i> teaches you how to cultivate leadership for your growing business.</b><br/><br/>You don't need to hope that leaders emerge from the ranks of your organization or that search firms can find the leaders you need in a timely fashion. Hope is not a strategy! In <i>Leaders Made Here</i>, Mark Miller teaches you how to build an organizational culture that will ensure your leadership pipeline is full and flowing. He offers clear, proven, and replicable strategies for nurturing leaders throughout the organization, from the front lines to the executive ranks. <br/><br/>To bring his ideas to life, Miller uses the story of Blake, a new CEO, and Charles and old friend and colleague, as they search for the best practices from around the world to ensure a continuous supply of their most precious asset – leaders. Blake and his team then translate their findings into a practical plan that any organization can use to create a leadership culture, sustained competitive advantage, and long-term success.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Mark Miller
      </h2>
      
      <p class="authorDescription body article">Mark Miller began his Chick-fil-A career working as an hourly team member in 1977. Since joining the corporate staff in 1978, he has provided leadership for corporate communications, field operations, quality and customer satisfaction, and training, organizational effectiveness, and leadership development. During his time with Chick-fil-A, annual sales have grown to over $7 billion, and the company has expanded to more than 2,000 restaurants.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Berrett–Koehler Publishers,
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?a5a69b4a